import { type UseMutationResult, useMutation } from '@tanstack/react-query';

type TopUpBodyRequest = {
    pageId: string;
    amount: number;
}

export type TopUpResponse = {
    isSuccess: boolean;
    data: {
        redirectUrl?: string | null;
    };
    errorMessages: string[] | null;
    exception: string | null;
}

const useTopUpMutation = (): UseMutationResult<any, unknown, TopUpBodyRequest> => {
    const endpoint = '/api/MCCPlus/accounts/current/topup-requests';

    const mutation = useMutation({
        mutationFn: async(data: TopUpBodyRequest): Promise<any> => {
            const response = await fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' },
            });

            if (!response.ok) {
                if (response.status === 400) {
                    const errorResponse = await response.json();
                    throw new Error(errorResponse.errorMessages?.[0] || 'Validation error occurred');
                }
                throw new Error('Unable to submit form');
            }

            const responseData = await response.json();

            if (!responseData.isSuccess) {
                throw new Error(`Form submission failed: ${responseData.errorMessages?.[0] || 'Unknown error'}`);
            }

            return responseData;
        },
    });

    return mutation;
};

export default useTopUpMutation;
